import PopupCopyInspection from './PopupCopyInspection';

export default PopupCopyInspection;
